const elementExists = document.querySelectorAll('.input-css-search');

elementExists.forEach(inputWrap => {
  // eslint-disable-next-line no-param-reassign
  inputWrap.querySelector('.search-submit').onclick = clickEvent => {
    const domEvent = document.createEvent('Event');
    domEvent.initEvent('submit', false, true);
    clickEvent.target.closest('form').dispatchEvent(domEvent);
  };
});
